// import '@fortawesome/fontawesome-free/css/all.css' // Ensure you are using css-loader
//import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import "@/assets/styles/style.less"
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

import en from 'vuetify/es5/locale/en'
import tr from 'vuetify/es5/locale/tr'


export default new Vuetify({
    lang: {
        locales: {
            tr,en
        },
        current: 'tr',
    },
    icons: {
        iconfont: 'mdiSvg',
    },
});